export enum FLOW_STEP_TYPE {
    ADD_TO_LIST = 'add_to_list',
    ASSOCIATE = 'associate',
    CHOICE = 'choice',
    COLLECT_USER_INFO = 'collect_user_info',
    CONDITION = 'condition',
    CONTACT_CARD = 'contact_card',
    END = 'end',
    EVENTS = 'events',
    MESSAGE = 'message',
    PRODUCT_CHOICE = 'product_choice',
    PRODUCT_VARIANT_CHOICE = 'product_purchase',
    PROMPT = 'prompt',
    PURCHASE = 'purchase',
    PURCHASE_OFFER = 'purchase_offer',
    RATE_LIMIT = 'rate_limit',
    REPOPULATE_PARAMETERS = 'repopulate_parameters',
    SHOPPING_SESSION = 'shopping_session',
    SEGMENT = 'segment',
    SPLIT = 'split',
    TRIGGER_FLOW = 'trigger_flow',
    VAULT = 'vault',
    WEBHOOK = 'webhook',
    WELCOME = 'welcome',
    CART_RECOMMENDATION = 'cart_recommendation',
    DELAY = 'delay',
    TRACK_CUSTOMER = 'track_customer'
}

export enum FLOW_STEP_EVENT_TYPE {
    COMPLETE = 'complete',
    CONDITION = 'condition',
    DELIVER = 'deliver',
    EXECUTE = 'execute',
    NOREPLY = 'noreply',
    PARTIAL_CHOICE_NO_REPLY = 'partial_choice_no_reply',
    PROMPT_RESPONSE = 'prompt_response',
    REPLY = 'reply',
    SPLIT = 'split',
    UNHANDLED_REPLY = 'unhandled_reply',
    WEBHOOK_RESPONSE = 'webhook_response',
    ERROR = 'error',
    NO_LATEST_CART = 'no_latest_cart'
}

export enum FLOW_TYPE_ALIAS {
    STRING = 'string',
    NUMBER = 'number',
    BOOLEAN = 'boolean',

    ORDER = 'Order',
    DISCOUNT = 'Discount',
    PRODUCT_ID = 'ProductID',
    VARIANT_ID = 'VariantID',

    HTTP_URL = 'HTTPUrl',

    STORE_PLATFORM = 'STORE_PLATFORM',

    ENUM = 'enum',
    LITERAL = 'literal',

    OBJECT = 'object',
    ARRAY = 'array',
    MAP = 'map',
    UNION = 'union'
}

export enum FLOW_VAR_NAMESPACE {
    PARAMETERS = 'parameters',
    STEP_PARAMETERS = 'stepParameters',
    STEP = 'step',
    USER = 'user',
    MERCHANT = 'merchant',
    EVENT = 'event',
    VALUE = 'value'
}

export enum FLOW_CONDITION_OPERATOR {
    DEFINED = 'defined',
    NOTDEFINED = 'notdefined',
    EQUAL = 'equal',
    NOTEQUAL = 'notequal'
}

export enum FLOW_RECEIVERS_TYPE {
    ACCOUNTS = 'accounts',
    ALL_SUBSCRIBERS = 'all_subscribers',
    CONTACTS = 'contacts',
    EXISTING_FLOW_INSTANCE_GROUP = 'existing_flow_instance_group',
    MARKETING_LIST = 'marketing_list',
    SEGMENT = 'segment'
}

export enum FLOW_RECEIVERS_EXCLUSION_TYPE {
    EVENT = 'event',
    MESSAGE = 'message'
}

export enum FLOW_SEGMENT_ACTION {
    EXCLUDE = 'exclude',
    INCLUDE = 'include'
}

export enum FLOW_SEGMENT_TYPE {
    EVENT = 'event'
}

export enum CUSTOM_FLOW_INSTANCE_GROUP_STATUS {
    CANCELED = 'canceled',
    DRAFT = 'draft',
    ERROR = 'error',
    LAUNCHED = 'launched',
    QUEUEING = 'queuing',
    SCHEDULED = 'scheduled'
}

export enum CUSTOM_FLOW_INSTANCE_STATUS {
    ACTIVE = 'active',
    COMPLETE = 'complete',
    ERROR = 'error',
    CANCELED = 'canceled'
}

export enum CUSTOM_FLOW_PARAMETER_NAME {
    ORDER = 'order',
    DISCOUNT = 'discount',
    PRODUCT_ID = 'productID',
    PRODUCT_NAME = 'productName'
}

export enum CORE_FLOW_TYPE {
    BROWSE_RECOVER = 'browse_recover',
    CHECKOUT_RECOVER = 'checkout_recover',
    CHECKOUT_RECOVER_REMINDER = 'checkout_recover_reminder',
    CART_RECOVER = 'cart_recover',
    CART_CONCIERGE = 'cart_concierge',
    CART_RECOMMENDATION = 'cart_recommendation',
    CART_UPDATE = 'cart_update',
    COLLECT_USER_INFO = 'collect_user_info',
    POST_PURCHASE = 'order_confirm',
    ORDER_SHIPPED = 'order_shipped',
    PRODUCT_CHOICE = 'product_choice',
    PRODUCT_OFFER = 'product_offer',
    PRODUCT_VARIANT_CHOICE = 'product_variant_choice',
    PRODUCT_VIEW_RECOVER = 'product_view_recover',
    PURCHASE_OFFER = 'purchase_offer',
    ONETEXT_WELCOME = 'onetext_welcome',
    CHECKOUT_WELCOME = 'checkout_welcome',
    WELCOME = 'welcome',
    PURCHASE_LINK = 'purchase_link',
    NO_STOCK_PARTIAL_ORDER = 'no_stock_partial_order',
    MANUAL_API_CALL = 'manual_api_call',
    SHOPIFY_APP_INSTALL = 'shopify_app_install',
    PAYPAL_CONNECT = 'paypal_connect',
    STRIPE_CONNECT = 'stripe_connect',
    WOO_CONNECT = 'woo_connect',
    ONBOARD_BUYER = 'onboard_buyer',
    QUEUE_REFILL_SUBSCRIPTION = 'queue_refill_subscription',
    SALES_AGENT = 'sales_agent',
    CONTACT_CARD = 'contact_card',
    SMS_OPT_IN = 'sms_opt_in',
    SMS_OPT_OUT = 'sms_opt_out',
    SUPPORT_REQUEST = 'support_request',
    MULTIFACTOR_OPT_IN = 'multifactor_opt_in',
    OPT_IN_FLOW = 'opt_in_flow',
    WINBACK = 'winback',
    FLOW_PREVIEW = 'flow_preview',
    INBOUND = 'inbound'
}

export enum AUTOMATION_TYPE {
    WELCOME = 'welcome',
    ORDER_RECOVERY = 'order_recovery',
    CART_CONCIERGE = 'cart_concierge',
    PRODUCT_VIEW_RECOVERY = 'product_view_recovery',
    BROWSE_RECOVERY = 'browse_recovery',
    POST_PURCHASE = 'post_purchase',
    WINBACK = 'winback'
}

export enum FLOW_TYPE {
    CORE = 'core',
    CUSTOM = 'custom'
}

export enum FLOW_GROUP_TYPE {
    CAMPAIGN = 'campaign',
    AUTOMATION = 'automation'
}

export enum FLOW_LOG_ACTION {
    UPDATE = 'update',
    AUTOMATION_DISABLE = 'automation_disable',
    AUTOMATION_ENABLE = 'automation_enable'
}

export const CORE_FLOW_TYPE_LABEL : {
    [ CoreFlowType in CORE_FLOW_TYPE ] : string
} = {
    [ CORE_FLOW_TYPE.BROWSE_RECOVER ]:            'Browse Recover',
    [ CORE_FLOW_TYPE.CHECKOUT_RECOVER ]:          'Checkout Recover',
    [ CORE_FLOW_TYPE.CHECKOUT_RECOVER_REMINDER ]: 'Checkout Recover Reminder',
    [ CORE_FLOW_TYPE.CART_RECOVER ]:              'Cart Recover',
    [ CORE_FLOW_TYPE.CART_CONCIERGE ]:            'Cart Concierge',
    [ CORE_FLOW_TYPE.WINBACK ]:                   'Winback',
    [ CORE_FLOW_TYPE.CART_RECOMMENDATION ]:       'Cart Recommendation',
    [ CORE_FLOW_TYPE.COLLECT_USER_INFO ]:         'Collect User Info',
    [ CORE_FLOW_TYPE.CART_UPDATE ]:               'Cart Update',
    [ CORE_FLOW_TYPE.POST_PURCHASE ]:             'Post Purchase',
    [ CORE_FLOW_TYPE.ORDER_SHIPPED ]:             'Order Shipped',
    [ CORE_FLOW_TYPE.PRODUCT_CHOICE ]:            'Product Choice',
    [ CORE_FLOW_TYPE.PRODUCT_OFFER ]:             'Product Offer',
    [ CORE_FLOW_TYPE.PRODUCT_VARIANT_CHOICE ]:    'Product Variant Choice',
    [ CORE_FLOW_TYPE.PRODUCT_VIEW_RECOVER ]:      'Product View Recover',
    [ CORE_FLOW_TYPE.PURCHASE_OFFER ]:            'Purchase Offer',
    [ CORE_FLOW_TYPE.ONETEXT_WELCOME ]:           'OneText Welcome',
    [ CORE_FLOW_TYPE.CHECKOUT_WELCOME ]:          'Checkout Welcome',
    [ CORE_FLOW_TYPE.WELCOME ]:                   'Welcome',
    [ CORE_FLOW_TYPE.PURCHASE_LINK ]:             'Purchase Link',
    [ CORE_FLOW_TYPE.NO_STOCK_PARTIAL_ORDER ]:    'No Stock Partial Order',
    [ CORE_FLOW_TYPE.MANUAL_API_CALL ]:           'Manual API Call',
    [ CORE_FLOW_TYPE.SHOPIFY_APP_INSTALL ]:       'Shopify App Install',
    [ CORE_FLOW_TYPE.PAYPAL_CONNECT ]:            'PayPal Connect',
    [ CORE_FLOW_TYPE.STRIPE_CONNECT ]:            'Stripe Connect',
    [ CORE_FLOW_TYPE.WOO_CONNECT ]:               'Woo Connect',
    [ CORE_FLOW_TYPE.ONBOARD_BUYER ]:             'Onboard Buyer',
    [ CORE_FLOW_TYPE.QUEUE_REFILL_SUBSCRIPTION ]: 'Refill Subscription',
    [ CORE_FLOW_TYPE.SALES_AGENT ]:               'Sales Agent',
    [ CORE_FLOW_TYPE.CONTACT_CARD ]:              'Contact Card',
    [ CORE_FLOW_TYPE.SMS_OPT_IN ]:                'SMS Opt In',
    [ CORE_FLOW_TYPE.SMS_OPT_OUT ]:               'SMS Opt Out',
    [ CORE_FLOW_TYPE.SUPPORT_REQUEST ]:           'Support Request',
    [ CORE_FLOW_TYPE.MULTIFACTOR_OPT_IN ]:        'Multifactor Opt In',
    [ CORE_FLOW_TYPE.OPT_IN_FLOW ]:               'Opt In Flow',
    [ CORE_FLOW_TYPE.FLOW_PREVIEW ]:              'Flow Preview',
    [ CORE_FLOW_TYPE.INBOUND ]:                   'Inbound Message'
};

export const CUSTOM_FLOW_MESSAGE_EXCLUSION_MAX_HOURS = 168;
export const CUSTOM_FLOW_BUYER_EVENT_EXCLUSION_MAX_HOURS = 720;

export const startableCoreFlows : [ CORE_FLOW_TYPE, ...Array<CORE_FLOW_TYPE> ] = [
    CORE_FLOW_TYPE.WELCOME
];

export enum AUDIENCE_SEGMENT_OPERATOR {
    AND = 'AND',
    OR = 'OR'
}

export enum AUDIENCE_SEGMENT_SELECTION_TYPE {
    EXCLUSION = 'exclusion',
    INCLUSION = 'inclusion'
}

export enum AUDIENCE_SEGMENT_TIME_HORIZON {
    WITHIN_LAST = 'within_last',
    ALL_TIME = 'all_time',
    SINCE_FLOW_START = 'since_flow_start'
}

export enum AUDIENCE_SEGMENT_ACTION_TYPE {
    EVENT = 'event',
    CUSTOMER_PROPERTY = 'customer_property',
    REFILL = 'refill'
}

export enum AUDIENCE_SEGMENT_EVENT_FILTER_PROPERTY {
    PRODUCT_ID = 'product_id',
    PRODUCT_TAGS = 'product_tags',
    PRODUCT_COLLECTIONS = 'product_collections',
    KEYWORD = 'keyword',
    LINK = 'link',
    CAMPAIGN = 'campaign',
    CART_SUBTOTAL = 'cart_subtotal'
}

export enum AUDIENCE_SEGMENT_EVENT_FILTER_OPERATOR {
    CONTAINS = 'contains',
    EQUALS = 'equals',
    GREATER_THAN_OR_EQUALS = 'greater_than_or_equals',
    LESS_THAN_OR_EQUALS = 'less_than_or_equals'
}

export enum AUDIENCE_SEGMENT_CUSTOMER_PROPERTY_FILTER {
    EQUALS = 'equals',
    NOT_EQUALS = 'not_equals',
    CONTAINS = 'contains',
    EXISTS = 'exists',
    NOT_EXISTS = 'not_exists'
}
